import { render, staticRenderFns } from "./InformacionPrincipalTabContent.vue?vue&type=template&id=3fefc29a"
import script from "./InformacionPrincipalTabContent.vue?vue&type=script&lang=js"
export * from "./InformacionPrincipalTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports